<div class="jumbotron jumbotron-fluid">
	<div class="container">
		<h1>Too many connections from this IP address</h1>

		<h2 class="mt-5">What happened?</h2>
		<p>
			We've detected a
			<strong class="badge badge-light">suspicious activity</strong> from your IP
			address and have temporarily blocked your access for
			<strong class="badge badge-light">15 minutes</strong> as a security
			precaution.
		</p>
		<p>
			If you are on a corporate network, please notify you network support team.
			Otherwise
			<strong class="badge badge-light">try again in 15 minutes</strong>
		</p>
	</div>
</div>
